import React, { createContext, useCallback, useEffect } from 'react';
import _axios from 'axios';
import { useNavigate } from 'react-router';

const LOCAL_STORAGE_KEY = 'WebinarReqToken';

const webinarAxios = _axios.create({
  baseURL: process.env.REACT_APP_WEBINAR_API,
  timeout: 20000,
  headers: { ln: 'fa' },
});

const recommendationAxios = _axios.create({
  baseURL: process.env.REACT_APP_RECOMMENDATION_API,
  timeout: 20000,
  headers: { ln: 'fa' },
});

export const WebinarRequestContext = createContext(undefined);

export const WebRequestProvider = ({ children }) => {
  const navigate = useNavigate();
  const setToken = (t) => {
    localStorage.setItem(LOCAL_STORAGE_KEY, t);
  };

  const getTokenAPI = useCallback(
    () =>
      new Promise((resolve, reject) => {
        const localToken = localStorage.getItem('token');
        if (true && !window?.location?.href?.includes('login')) {
          _axios
            .post('/admin/auth/getWebinarAdminToken', undefined, {
              headers: {
                lt: localToken,
              },
            })
            .then((res) => {
              setToken(res?.data?.jwtToken);
              resolve(res?.data);
            })
            .catch((err) => {
              console.log('-----------------');

              if (err?.response?.data?.key === 'err.invalidJWTToken') {
                console.log('----------------- 2');
                navigate('/login');
              }
              reject(err);
            });
        }
      }),
    [navigate]
  );

  const apiCall = useCallback(
    async (payload) => {
      const { url, method, data = undefined, params = undefined } = payload;

      return new Promise((resolve, reject) => {
        const localToken = localStorage.getItem(LOCAL_STORAGE_KEY);

        webinarAxios({
          url,
          method,
          data,
          params,
          headers: {
            lt: localToken,
            ln: 'fa',
          },
        })
          .then((res) => {
            resolve(res?.data);
          })
          .catch((err) => {
            if (err?.response?.data.key === 'err.invalidJWTToken') {
              getTokenAPI(true).then(() => {
                resolve(apiCall(payload));
              });
            } else {
              reject(err);
            }
          });
      });
    },
    [getTokenAPI]
  );

  const recomApiCall = useCallback(
    async (payload) => {
      const { url, method, data = undefined, params = undefined } = payload;

      return new Promise((resolve, reject) => {
        const localToken = localStorage.getItem(LOCAL_STORAGE_KEY);

        recommendationAxios({
          url,
          method,
          data,
          params,
          headers: {
            lt: localToken,
            ln: 'fa',
          },
        })
          .then((res) => {
            resolve(res?.data);
          })
          .catch((err) => {
            if (err?.response?.data.key === 'err.invalidJWTToken') {
              getTokenAPI(true).then(() => {
                resolve(recomApiCall(payload));
              });
            } else {
              reject(err);
            }
          });
      });
    },
    [getTokenAPI]
  );

  useEffect(() => {
    getTokenAPI();
  }, [getTokenAPI]);

  return (
    <WebinarRequestContext.Provider
      value={{
        apiCall,
        recomApiCall,
        token: localStorage.getItem(LOCAL_STORAGE_KEY),
      }}
    >
      {children}
    </WebinarRequestContext.Provider>
  );
};

export default WebRequestProvider;
